import { ChevronDown, ChevronUp } from 'lucide-react'
import { createElement } from 'react'
import { COLLECTION_ICON_BY_TYPE } from '../collection-icon-by-type'
import { TemplateItem } from '../template-item'
import clsx from 'clsx'

export type CollectionTemplateTreeItemProps = {
  item: TemplateItem
  isFolderOpen: boolean
  isSelected: boolean
  onClickItem?: () => void
}

export function CollectionTemplateTreeItem (props: CollectionTemplateTreeItemProps) {
  const { isFolderOpen, isSelected, onClickItem } = props
  const { name, type, children } = props.item

  return (
    <div
      className={clsx(
        'flex gap-2 items-center py-2 my-2 px-2 rounded-md hover:bg-gray-200 cursor-pointer text-base transition-all duration-150',
        { 'bg-gray-200': isSelected },
        { 'manrope-regular': type === 'database' },
        { 'manrope-bold': type === 'folder' }
      )}
      onClick={onClickItem}
    >
      {createElement(
        COLLECTION_ICON_BY_TYPE[type],
        { size: 16 }
      )}
      <span>{name ?? 'Sem título'}</span>
      {children && isFolderOpen && <ChevronUp size={13} className="ml-auto" /> }
      {children && !isFolderOpen && <ChevronDown size={13} className="ml-auto" />}
    </div>
  )
}
